import script from "./TabulatorPageFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./TabulatorPageFilter.vue?vue&type=script&setup=true&lang=js"

import "./TabulatorPageFilter.vue?vue&type=style&index=0&id=65e08495&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65e08495"]])

export default __exports__